export default "__VITE_ASSET__Ck6hyiEw__"